// The pane-switch effect (tabs & sub-screens): call the returned trigger on a switch and
// bind the flag into the pane container's class — .pane-in plays a .22s fade-rise
// (aboo.css; prefers-reduced-motion honoured). The flag self-clears so ordinary
// re-renders (search, pager, edits) never replay the animation.
import { signal } from './t4.js';

export function paneFx(clearMs = 600){
  const on = signal(false);
  let timer = null;
  const fire = () => {
    on.value = true;
    clearTimeout(timer);
    timer = setTimeout(() => { on.value = false; }, clearMs);
  };
  fire.on = on;                                        // read .on.value in reactive bodies
  fire.cls = base => () => base + (on.value ? ' pane-in' : '');   // reactive class helper
  return fire;
}
